import {useState} from 'react';
import CCBadgeLight,{getValidColor, getValidSize, propsDefaults as badgePropsDefaults} from '../index';
import CCBadgeLightRemoveControl, {propsDefaults as removeControlPropsDefaults} from '../../_RemoveControl';

const constants = Object.freeze({
  COMPONENT_NAME: 'CCBadgeLightRemovable',
  REMOVE_CONTROL_MARGIN_CLASSNAME: {
    badgeSize_small: 'ml-2',
    badgeSize_medium: 'ml-2',
    badgeSize_large: 'ml-2'
  }
});

function getRemoveControlMarginClassName(badgeSize) {
  return constants.REMOVE_CONTROL_MARGIN_CLASSNAME[`badgeSize_${badgeSize}`];
}
export default function CCBadgeLightRemovable(
  {
    size = badgePropsDefaults.size,
    color = badgePropsDefaults.color,
    removeControlTitle = removeControlPropsDefaults.title,
    isRemoveControlDisabled= removeControlPropsDefaults.isDisabled,
    removeControlFn = removeControlPropsDefaults.fn,
    removeControlFnArgs = removeControlPropsDefaults.fnArgs,
    className = badgePropsDefaults.className,
    children
  }
) {
  const [isRemoved, setIsRemoved] = useState(false);
  const validSize = getValidSize(size, constants.COMPONENT_NAME);
  const validColor = getValidColor(color, constants.COMPONENT_NAME);
  if(!isRemoved) {
    return (
      <CCBadgeLight size={validSize}
                    color={validColor}
                    tag='div'
                    className={className}
                    validateProps={false}>
        {children}
        <CCBadgeLightRemoveControl badgeSize={validSize}
                                   badgeColor={validColor}
                                   title={removeControlTitle}
                                   isDisabled={isRemoveControlDisabled}
                                   fn={!!removeControlFn?removeControlFn:setIsRemoved}
                                   fnArgs={!!removeControlFn?removeControlFnArgs:!isRemoved}
                                   className={getRemoveControlMarginClassName(validSize)}/>
      </CCBadgeLight>
    );
  }
  return null;
}
